import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { BrandMark } from "@/components/BrandMark";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    // The backend has already set the session_token cookie during
    // /api/auth/google/callback, so we just hydrate the AuthContext and
    // route home. On failure, /auth/me returns 401 and we surface a retry.
    (async () => {
      try {
        await refresh();
        window.history.replaceState(null, "", "/");
        navigate("/", { replace: true });
      } catch {
        setError("Couldn't complete sign-in. Please try again.");
      }
    })();
  }, [navigate, refresh]);

  return (
    <div
      className="min-h-screen flex items-center justify-center px-6"
      style={{ background: "#f6f1e7" }}
    >
      <div className="text-center" style={{ color: "#3a2f24" }}>
        <div className="mb-4 flex justify-center">
          <BrandMark className="text-3xl opacity-80" signOnMount={false} testid="auth-callback-brand" />
        </div>
        <p className="text-lg opacity-90">
          {error || "Settling you in…"}
        </p>
        {error && (
          <button
            data-testid="auth-callback-retry"
            className="mt-6 px-6 py-2 rounded-full"
            style={{ background: "#3a2f24", color: "#f6f1e7" }}
            onClick={() => (window.location.href = "/login")}
          >
            Back to sign in
          </button>
        )}
      </div>
    </div>
  );
}
